import { theme } from '@ublend-npm/aulaui-next';
import React from 'react';
import {
  BackgroundLoader,
  Loader,
  Loaders,
  LoadingGroup,
  LoadingLabel,
} from './Loading.styled';

export type LoadingProps = {
  progress?: number;
};

export const Loading = ({ progress }: LoadingProps) => (
  <LoadingGroup data-testid="loading">
    <Loaders>
      {progress != null ? (
        <BackgroundLoader
          color={theme.color.designSystem.grey20}
          progress={100}
        />
      ) : null}
      <Loader progress={progress} />
    </Loaders>
    {progress != null ? <LoadingLabel>{progress}%</LoadingLabel> : null}
  </LoadingGroup>
);
